<template>
  <div class="" v-if="item.id">
    <section class="video-player">
      <div class="container">
        <div class="quest-container maxhd" v-if="isAllowed===true && testqsActive && !testqsSkip">
          <testqs-overlay :item="item" :group="testqsActive" :index="testqsIndex" v-on:close="closeTest" v-on:again="tryAgain" v-on:close2="testqsSkip=true;testqsActive=null"></testqs-overlay>
        </div>
        <div class="top-video-container maxhd" v-if="(videoUrl || introPhotoUrl) && isAllowed===true">
          <videoplayer :src="videoUrl" :poster="posterUrl" v-if="videoUrl" :loop="item.type && item.type.id==5" :chapters="item.chapters" v-on:duration="setDuration" v-on:seek="setTime" :paused="!!testqsActive || testqsSkip" :introVideo="introVideo" :outroVideo="outroVideo" />
          <div class="tv-inner" v-else-if="introPhotoUrl">
            <div class="video-container">
              <img :src="introPhotoUrl" />
              <div class="quest" v-if="isIndependent && isAllowed">
                <span v-if="!isIndependentDone" class="stat">Pending</span>
                <span v-else class="stat">Completed</span>
                <h2>Questionare</h2>
                <p v-if="!isIndependentDone">You haven’t completed our questionnaire yet, please do it by clicking on the start button.</p>
                <p v-else>You have completed this questionnaire.</p>
                <a v-if="!isIndependentDone" href="" class="qbtn" v-on:click.prevent="testqsActive=item.testqs.independent;testqsIndex=0;testqsSkip=false">Start</a>
              </div>
            </div>
          </div>
        </div>
        <div class="top-video-container maxhd" v-if="(videoUrl || introPhotoUrl) && isAllowed===false">
          <div class="tv-inner">
            <div class="video-container">
              <img :src="posterUrl || introPhotoUrl" class="blurred" />
            </div>
          </div>
          <group-details-vid :group="item.group && item.group.id" :video2="item" :video="item.parent?item.parent:item" :noPpatt="isVideoPpatt && !isUserPpatt" />
        </div>
      </div>
    </section>
    <section class="page-content">
      <div class="container">
        <div class="pg-main text-content">
          <h1>{{ item.parent?item.parent.subtitle:item.subtitle }} {{ item.title }}</h1>
          
          <template v-for="(block, bi) in item.blocks">
            <div class="intro" v-if="block.type=='intro'" v-html="block.content"></div>
            <div class="post-text" v-else-if="block.type=='text'" v-html="block.content"></div>
            <div class="post-full-img" v-else-if="block.type=='image'" :class="{pfileft: block.prefix=='left', pfiright: block.prefix=='right'}">
              <img v-if="isPhoto(block.media)" :src="photoLink(block.media)" />
              <div class="ext-link" v-else-if="isAllowed===true || isExpired===true"><a target="_blank" :href="photoLink(block.media)">Download: {{ fileName(block.media) }}</a></div>
              <div class="ext-link" v-else><a>Download: {{ fileName(block.media) }}</a></div>
            </div>
            <h2 v-else-if="block.type=='h2'">{{ block.content }}</h2>
            <blockquote v-else-if="block.type=='blockquote'">
              <div class="before"><span></span></div>
              <div v-if="hasText(block.prefix)" v-html="block.prefix" class="title"></div>
              <div v-html="block.content"></div>
              <div v-if="hasText(block.suffix)" v-html="block.suffix" class="signature"></div>          
              <div class="after"><span></span></div>
            </blockquote>
          </template>
          <edit-tags :edit="false" :item="item" />

        </div>
        <aside>
          <div class="vprop">
            <date>{{ formatDate(item.created, "MMM Do, YYYY") }}</date>
            <span class="cat">{{ item.type && item.type.title }}</span>
          </div>
          <div class="vact">
            <share />
            <a href="" class="fav" :class="{active: existingLike}" v-on:click.prevent="toggleLike">Favourite</a>
          </div>
          <div class="quest" v-if="false && isIndependent && isAllowed">
            <span v-if="!isIndependentDone" class="stat">Pending</span>
            <span v-else class="stat">Completed</span>
            <h2>Questionare</h2>
            <p v-if="!isIndependentDone">You haven’t completed our questionnaire yet, please do it by clicking on the start button.</p>
            <p v-else>You have completed this questionnaire.</p>
            <a v-if="!isIndependentDone" href="" class="qbtn" v-on:click.prevent="testqsActive=item.testqs.independent;testqsIndex=0;testqsSkip=false">Start</a>
          </div>
          <div class="videos-list" v-if="item.allVideos && item.allVideos.length">
            <h3><label>Content in:</label> {{ item.parent?item.parent.subtitle:item.subtitle }}</h3>
            <ul>
              <li v-for="relVideo in item.allVideos" :class="{active: item.id==relVideo.id}">
                <img :src="itemPoster(relVideo)" />
                <div class="details">
                  <router-link :to="{name: 'content', params: {id: relVideo.id}}">{{ relVideo.title }}</router-link>
                  <date>{{ formatDate(relVideo.created, "MMM Do, YYYY") }}</date>
                </div>
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </section>
    
    <section class="gen-list" v-if="false">
      <div class="container">
        <div class="gs-head">
          <h2>Related Videos</h2>
          <a href="" class="lnk-list">see all</a>
        </div>
        <ul class="gen-list-content">
          <li class="vid">
            <div class="preview">
              <img src="temp/list1.jpg" />
              <span class="video"></span>
              <span class="cat">Workshop</span>
              <span class="stat active">Jul 17th 2021</span>
            </div>
            <div class="desc">
              <h5><a href="">Sample video title to test long video names</a></h5>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus volutpat ipsum eget urna vehicula dictum. Nulla semper felis ipsum, sed condimentum leo pretium ut. Donec consectetur turpis ac ante vestibulum rhoncus.</p>
              <date>Jan 13th, 2021</date>
            </div>
            <a href="" class="wlink"></a>
          </li>
          <li class="">
            <div class="preview">
              <img src="temp/list1.jpg" />
              <span class="video"></span>
              <span class="cat">Workshop</span>
            </div>
            <div class="desc">
              <h5><a href="">Sample video title to test long video names</a></h5>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus volutpat ipsum eget urna vehicula dictum. Nulla semper felis ipsum, sed condimentum leo pretium ut. Donec consectetur turpis ac ante vestibulum rhoncus.</p>
              <date>Jan 13th, 2021</date>
            </div>
            <a href="" class="wlink"></a>
          </li>
          <li class="vid">
            <div class="preview">
              <img src="temp/list1.jpg" />
              <span class="video"></span>
              <span class="cat">Workshop</span>
              <span class="stat locked"></span>
            </div>
            <div class="desc">
              <h5><a href="">Sample video title to test long video names</a></h5>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus volutpat ipsum eget urna vehicula dictum. Nulla semper felis ipsum, sed condimentum leo pretium ut. Donec consectetur turpis ac ante vestibulum rhoncus.</p>
              <date>Jan 13th, 2021</date>
            </div>
            <a href="" class="wlink"></a>
          </li>
          <li class="vid">
            <div class="preview">
              <img src="temp/list1.jpg" />
              <span class="video"></span>
              <span class="cat">Workshop</span>
              <span class="stat permanent"></span>
            </div>
            <div class="desc">
              <h5><a href="">Sample video title to test long video names</a></h5>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus volutpat ipsum eget urna vehicula dictum. Nulla semper felis ipsum, sed condimentum leo pretium ut. Donec consectetur turpis ac ante vestibulum rhoncus.</p>
              <date>Jan 13th, 2021</date>
            </div>
            <a href="" class="wlink"></a>
          </li>
          
          
          
          
          
          
          
          
        </ul>
      </div>
    </section>
  
  
  <div class="seg-content page" v-if="false">
    <div class="post-container">
      <div class="post-head">
        <div class="ph-split">
          <div class="type"><span v-if="item.type"><i></i></span></div>
          <div class="group" style="max-width: 230px">
            <span v-if="item.group">
              <router-link :to="{name: 'group', params: {group: item.group.id}}">{{ item.group.title }}</router-link>
            </span>
            <span v-else></span>
          </div>
          <div class="post-tools">
            <ul>
              <li class="comments" v-if="item.hasComments">
                <a href="" v-on:click.prevent="goComments">Go to comments</a>
                <span>{{ item.comments.length }}</span>
              </li>
              <li class="likes">
                <a href="" v-on:click.prevent="toggleLike">Like</a>
                <span>{{ item.likes }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="ph-split">
          <div>
            <h1></h1>
            <h2 class="subtitle" v-if="item.subtitle">{{ item.subtitle }}</h2>
          </div>
          <div class="auth" v-if="item.author">
            <div class="auth-img"><i></i>
              <router-link :to="{name: 'content.teacher', params: {id: item.author.username}}">
                <img :src="photoLinkR(item.author.media, 256, 256, 'Fit')" />
              </router-link>
            </div>
            <div>
              <div class="name">{{ item.author.pubname }}</div>
              <div class="role">{{ item.author.title }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="post-content">
        
        <template v-for="(block, bi) in item.blocks">
          <div class="intro" v-if="block.type=='intro'" v-html="block.content"></div>
          <div class="post-text" v-else-if="block.type=='text'" v-html="block.content"></div>
          <div class="post-full-img" v-else-if="block.type=='image'" :class="{pfileft: block.prefix=='left', pfiright: block.prefix=='right'}">
            <img v-if="isPhoto(block.media)" :src="photoLink(block.media)" />
            <div class="ext-link" v-else-if="isAllowed===true || isExpired===true"><a target="_blank" :href="photoLink(block.media)">Download: {{ fileName(block.media) }}</a></div>
            <div class="ext-link" v-else><a>Download: {{ fileName(block.media) }}</a></div>
          </div>
          <h2 v-else-if="block.type=='h2'">{{ block.content }}</h2>
          <blockquote v-else-if="block.type=='blockquote'">
            <div class="before"><span></span></div>
            <div v-if="hasText(block.prefix)" v-html="block.prefix" class="title"></div>
            <div v-html="block.content"></div>
            <div v-if="hasText(block.suffix)" v-html="block.suffix" class="signature"></div>          
            <div class="after"><span></span></div>
          </blockquote>
        </template>
        <edit-tags :edit="false" :item="item" />
      </div>
      <div class="post-comments" ref="comments" v-if="item.hasComments">
        <h4>{{ formatPlural(item.comments.length, "comment") }}</h4>
  <ul>
    <template v-for="(comment, ci) in item.comments">
    <li v-if="comment.parent==null">
      <div class="type" v-on:click.prevent="openReply(ci)">Reply</div>
      <div class="author"><span v-if="comment.author">{{ comment.author.firstname+" "+comment.author.lastname }}</span></div>
      <div class="auth-img" v-if="comment.author && comment.author.media"><img :src="photoLink(comment.author.media)" /></div>
      <div class="comment-text" v-html="escapeText(comment.content)"></div>
      <time>{{ formatDate(comment.created, "MMM Do, YYYY [at] h:mm a") }}</time>
    </li>
    <li v-for="(comment2, ci2) in item.comments" v-if="comment2.parent==comment.id" class="reply">
      <div class="author"><span v-if="comment2.author">{{ comment2.author.firstname+" "+comment2.author.lastname }}</span></div>
      <div class="auth-img" v-if="comment2.author && comment2.author.media"><img :src="photoLink(comment2.author.media)" /></div>
      <div class="comment-text" v-html="escapeText(comment2.content)"></div>
      <time>{{ formatDate(comment2.created, "MMM Do, YYYY [at] h:mm a") }}</time>
    </li>
    <li class="form reply" v-if="replyId==comment.id && currentUser">
      <div class="type">Leave a Reply</div>
      <div class="auth-img" v-if="currentUser.media"><img :src="photoLink(currentUser.media)" /></div>
      <form v-on:submit.prevent="submitReply">
        <textarea ref="replyBox" v-model="replyComment"></textarea>
        <button>Send</button>
      </form>
    </li>
    </template>
    <li class="form" v-if="currentUser">
      <div class="type">Leave a Comment</div>
      <div class="auth-img" v-if="currentUser.media"><img :src="photoLink(currentUser.media)" /></div>
      <form v-on:submit.prevent="submitComment">
        <textarea ref="commentBox" v-model="newComment"></textarea>
        <button>Send</button>
      </form>
    </li>
  </ul>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import moment from 'moment';
import api from './api';
import mainNav from './mainNav';
import dateLimit from './dateLimit';
import payment from './payment';

export default {
  mixins: [mainNav, dateLimit, payment],
  data: ()=>({
    item: {comments: []},
    replyId: null,
    replyComment: "",
    newComment: "",
    currentUser: {},
    playlists: false,
    newPlaylistName: "",
    videoThumbs: {},
    videoPayment: null,
    typePayment: null,
    time: 0,
    duration: 0,
    testqsActive: null,
    testqsSkip: false,
    testqsIndex: null,
    testTakes: [],
    introVideo: "/static/img/vid-intro.mp4",
    outroVideo: "/static/img/vid-outro.mp4",
    existingLike: null,
  }),
  created() {
    this.loadCurrentUser();
    this.loadTags();
  },
  watch: {
    time: {
      async handler() {
        if (!this.isInteractive)
          return;
        this.testqsSkip=false;
        this.paused=false;
        await new Promise(resolve=>setTimeout(resolve, 160));
        if (!this.nextInteractiveToDo || this.nextInteractiveToDo.chapter.time>this.time) {
          this.testqsActive=null;
          this.testqsIndex=null;
        } else {
          this.testqsIndex=this.nextInteractiveToDo.index;
          this.testqsActive=this.nextInteractiveToDo;
        }
      },
      immediate: true,
    },
  },
  computed: {
    introPhotoUrl() {
      var media=this.item.media;
      if (!media || !media.store || media.store.plugin!="Local")
        return null;
      return media.store.rootUrl+media.path;
    },
    videoUrl() {
      var media=this.item.media;
      if (media && media.store && media.store.plugin=="Video2")
        return media.path;
      if (!media || !media.store || media.store.plugin!="Video")
        return null;
      return media.store.rootUrl+media.path;
    },
    posterUrl() {
      if (this.item.thumbnail) {
        var media=this.item.thumbnail;
        if (!media || !media.store || media.store.plugin!="Local")
          return null;
        return media.store.rootUrl+media.path;
      }
      var media=this.item.media;
      if (media && media.store && media.store.plugin=="Video2")
        return media.thumbnail;
      if (!media || !media.store || media.store.plugin!="Video")
        return null;
      return media.store.rootUrl+media.path.replace(/\/[^/]+$/, "/"+media.thumbnail);
    },
    isAllowed() {
      if (!this.item.media)
        return true;

      if (this.item.testqs && this.item.testqs.independent && this.item.testqs.independent.passingScore && this.isUserPpatt)
        return true;

      var activeVideoPayment=this.videoPayment && this.videoPayment.isActive?this.videoPayment:null;
      var activeTypePayment=this.typePayment && this.typePayment.isActive?this.typePayment:null;
      return !!(activeVideoPayment || activeTypePayment);
    },
    isVideoPpatt() {
      if (!this.item)
        return false;
      var type=appData.videoTypes.find((a)=>this.item.type && a.id==this.item.type.id);
      while(type && type.parent)
        type=appData.videoTypes.find((a)=>a.id==type.parent);
      if (type && type.slug=="ppatt")
        return true;
      return false;
    },
    isUserPpatt() {
      return appRoot.loggedIn && appRoot.loggedIn.hasPpatt;
    },
    isExpired() {
      return !!(this.videoPayment || this.typePayment);
    },
    isIndependent() {
      if (!this.item)
        return false;
      var testqs=this.item.testqs;
      return testqs && testqs.type=='independent' && testqs.independent && testqs.independent.questions.length;
    },
    isIndependentDone() {
      if (!this.isIndependent)
        return false;
      var testqs=this.item.testqs;
      if (this.item.password=="homework")
        return false;
//       return false; // TODO Remove me
      return !!this.testTakes.find(a=>a.passed);
    },
    isInteractive() {
      if (!this.item)
        return false;
      var testqs=this.item.testqs;
      return testqs && testqs.type=='interactive' && testqs.interactive && testqs.interactive.map(a=>a.questions.length).reduce((a,b)=>a+b, 0);
    },
    nextInteractiveToDo() {
      if (!this.isInteractive)
        return null;
      var testqs=this.item.testqs.interactive;
      for(var i in testqs) {
        if (this.isInteractiveDone(i))
          continue;
        return {...testqs[i], chapter: this.item.chapters[i], index: i};
      }
      return null;
    }
  },
  methods: {
    itemPoster(item) {
      if (item.thumbnail) {
        var media=item.thumbnail;
        if (!media || !media.store || media.store.plugin!="Local")
          return null;
        return media.store.rootUrl+media.path;
      }
      var media=item.media;
      if (!media || !media.store || media.store.plugin!="Video")
        return null;
      return media.store.rootUrl+media.path.replace(/\/[^/]+$/, "/"+media.thumbnail);
    },
    async closeTest() {
      await this.loadItem();
      this.testqsActive=null;
      this.testqsIndex=null;
    },
    async tryAgain() {
      var oldQsActive=this.testqsActive;
      this.testqsActive=null;
      await this.loadItem();
      this.$nextTick(()=>{
        this.testqsActive=oldQsActive;
      });
    },
    isInteractiveDone(groupIndex) {
      if (!this.isInteractive)
        return true;
      var testqs=this.item.testqs;
      if (groupIndex===undefined || groupIndex===null) {
        var done=true;
        for(var i in testqs.interactive)
          done=done && this.isInteractiveDone(i);
        return done;
      }
      var qs=testqs.interactive[groupIndex];
      if (!qs || !qs.passingScore)
        return true;
      return !!this.testTakes.find(a=>a.passed*1 && a.answers && a.answers.index==groupIndex);
    },
    hasText(text) {
      return (text || "").replace(/\<[^>]*\>/g, "").trim();
    },
    async loadCurrentUser() {
      this.userProfile=window.appRoot.loggedIn;
      await this.loadItem();
      if (!this.item.media /*|| this.userProfile.admin==1*/)
        return this.isAllowed=true;

      
      this.videoPayment=this.paymentForVideo(this.item.id, this.item.parent && this.item.parent.id);
      
      this.typePayment=this.paymentForType(this.item.type && this.item.type.id);
    },
    openReply(index) {
      this.replyComment="";
      this.replyId=this.item.comments[index].id;
      this.$nextTick(()=>{
        this.$refs.replyBox[0].focus();
      });
    },
    async submitReply() {
      var newComment=(await api.create("Comment", {
        created: "CURRENT_TIMESTAMP",
        author: this.currentUser.id,
        parent: this.replyId,
        post: this.item.id,
        content: this.replyComment,
      }, true)).item;
      this.replyComment="";
      this.replyId=null;
      var newComments=this.item.comments.slice();
      newComments.push(newComment);
      this.item.comments=newComments;
    },
    async submitComment() {
      var newComment=(await api.create("Comment", {
        created: "CURRENT_TIMESTAMP",
        author: this.currentUser.id,
        parent: null,
        post: this.item.id,
        content: this.newComment,
      }, true)).item;
      this.newComment="";
      var newComments=this.item.comments.slice();
      newComments.push(newComment);
      this.item.comments=newComments;
    },
    async loadItem() {
      console.log("Loading item");
      var id=this.$route.params.id;
      if (id/* && window.appRoot.loggedIn*/)
        this.item=(await api.get("Video", id)).item || {};
        
      this.isPpatt=window.appRoot.loggedIn && window.appRoot.loggedIn.hasPpatt;
      if (this.item.password && !this.isPpatt)
        location.replace("/");

      if (window.appRoot.loggedIn)
        this.testTakes=(await api.list("TestTake", {user: window.appRoot.loggedIn.id, video: id})).items;
      for(var ci in this.item.chapters || []) {
        this.$set(this.item.chapters[ci], "passed", this.isInteractiveDone(ci));
      }
      if (!this.item.blocks)
        this.item.blocks=[];
      this.item.blocks.sort((a,b)=>{
        if (a.order_index*1<b.order_index) return -1;
        if (a.order_index*1>b.order_index) return 1;
        return 0;
      });
      if (appRoot.loggedIn)
        this.existingLike=!!(await api.list("VideoLike", {video: this.item.id, user: appRoot.loggedIn.id})).items[0];
    },
    photoLink(media) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return media.store.rootUrl+media.path;
    },
    photoLinkR(media, width, height, mode) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return '/api/Media/'+media.id+'/resize?w='+width+"&h="+height+"&m="+mode;
    },
    isPhoto(media) {
      var link=this.photoLink(media);
      if (!link)
        return false;
      var ext=link.split(".").pop().toLowerCase();
      return ["jpg", "jpeg", "jpe", "png", "gif", "webp", "bmp"].indexOf(ext)!=-1;
    },
    fileName(media) {
      var link=this.photoLink(media);
      if (!link)
        return false;
      return link.split("/").pop().replace(/\.[^.]*$/, "");
    },
    goComments() {
      var $comments=$(this.$refs.comments);
      $("html,body").animate({scrollTop: $comments.offset().top}, 300);
    },
    async loadPlaylists() {
      if (this.playlists) {
        this.playlists=false;
        this.newPlaylistName="";
      } else {
        this.playlists=[];
        this.playlists=(await api.list("Playlist", {user: this.currentUser.id})).items;
        this.videoThumbs={};
        
        var thumbsPromises=[];
        for(var playlist of this.playlists) {
          if (playlist.videos && playlist.videos.length) {
            thumbsPromises.push(async()=>({
              id: playlist.id, 
              thumb: this.photoLinkR((await api.get("Video", playlist.videos[0])).item.thumbnail, 256, 256, 'Fit')
            }));
          } else {
            thumbsPromises.push({id: playlist.id, thumb: null});
          }
        }
        var thumbs=Promise.all(thumbsPromises);
        for(var i in thumbs) {
          var thumb=thumbs[i];
          this.$set(this.videoThumbs, thumb.id, thumb.thumb);
        }
      }
    },
    async addToPlaylist(playlist) {
      var videos=(playlist || {}).videos || [];
      videos.push(this.$route.params.id);
      if (playlist)
        await api.update("Playlist", playlist.id, {videos: videos});
      else
        await api.create("Playlist", {user: this.currentUser.id, videos: videos, title: this.newPlaylistName});
      this.playlists=false;
      this.newPlaylistName="";
    },
    escapeText(text) {
      return (text || "")
        .replace(/&/g, "&amp;")
        .replace(/\</g, "&lt;")
        .replace(/\>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/\n/g, "<br />\n");
    },
    formatPlural(count, prefix) {
      if (count==0)
        return "No "+prefix+"s";
      if (count==1)
        return count+" "+prefix;
      return count+" "+prefix+"s";
    },
    formatDate(date, format) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format(format);
    },
    async toggleLike() {
      if (!appRoot.loggedIn)
        return;
      var existingLike=(await api.list("VideoLike", {video: this.item.id, user: appRoot.loggedIn.id})).items[0];
      if (existingLike) {
        await api.delete("VideoLike", existingLike.id);
        if (this.item.likes>0)
          this.item.likes--;
        api.update("Video", this.item.id, {likes: this.item.likes});
        this.existingLike=false;
      } else {
        await api.create("VideoLike", {video: this.item.id, user: appRoot.loggedIn.id});
        this.item.likes++;
        api.update("Video", this.item.id, {likes: this.item.likes});
        this.existingLike=true;
      }
    },
    setTime($event) {
      this.time=$event;
    },
    setDuration($event) {
      this.duration=$event;
    },
  },
}
</script>
